<template>
  <div class="notice-new"
       @mouseleave="onMouseLeave"
       @mouseenter="onMouseEnter"
  >
    <div class="notice-wrapper">
      <i class="icon"></i>
      <span class="content">
        <marquee
            v-show="scrolling"
            id="marquee"
            ref="marquee"
            @mouseover="onMouseOver"
            @mouseout="onMouseOut"
        ><slot></slot></marquee>
        <p
            v-show="!scrolling"
            id="scrollMore"
            ref="scrollMore"
        ><slot></slot></p>
      </span>
      <span
          v-if="showBtn"
          :class="['notice-arrow', !scrolling && 'active']"
          @click="onStartMaqueeFun"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Notice",
  data() {
    return {
      timer: null,
      step: 0,
      noticeCont: null,
      noticeElem: null,
      scrolling: false,
      showBtn: false,
      endY: 0,
      $dom: null,
      $maq: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      try {
        const { hostname } = window.location;
        this.$dom = this.$refs.scrollMore;
        this.$maq = this.$refs.marquee;
        anime.set(this.$dom, { visibility: 'hidden' });
        this.endY = anime.get(this.$dom, 'height');
        anime.set(this.$dom, { visibility: '' });
        this.showBtn = parseInt(this.endY) > 20;
        if (this.showBtn) {
          if (!this.publicMethod.getCookie('dffl_notice_pc_isExist')) {
            this.publicMethod.setCookie(
                'dffl_notice_pc_isExist',
                true,
                604800,
                '/',
                `.${hostname}`,
            );
            anime({
              targets: this.$dom,
              height: this.endY,
              begin: () => {
                anime.set(this.$maq, { display: 'none' });
                anime.set(this.$dom, { display: '-webkit-box' });
              },
            });
          } else {
            this.scrolling = !this.scrolling;
          }
        } else {
          this.scrolling = !this.scrolling;
        }
      } catch (error) {
        console.log(error);
      }
    });
  },
  methods: {
    onStartMaqueeFun(ev) {
      try {
        ev.stopPropagation();
        if (this.scrolling) {
          this.$maq.stop();
          this.scrolling = !this.scrolling;
          anime({
            targets: this.$dom,
            height: this.endY,
          });
        } else {
          anime.set(this.$dom, { height: 0 });
          this.scrolling = !this.scrolling;
          this.$maq.start();
        }
      } catch (error) {
        console.log(error);
      }
    },
    onMouseOver(ev) {
      try {
        ev.stopPropagation();
        this.$maq.stop();
        if (this.showBtn) {
          this.scrolling = !this.scrolling;
          anime({
            targets: this.$dom,
            height: this.endY,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    onMouseOut(ev) {
      try {
        if (!this.showBtn) {
          ev.stopPropagation();
          this.$maq.start();
        }
      } catch (error) {
        console.log(error);
      }
    },
    onMouseLeave(ev) {
      try {
        ev.stopPropagation();
        if (!this.scrolling) {
          this.timer = setTimeout(() => {
            this.scrolling = !this.scrolling;
            anime.set(this.$dom, { height: 0 });
            anime.set(this.$maq, { display: 'block' });
            this.$maq.start();
          }, 1000);
        }
      } catch (error) {
        console.log(error);
      }
    },
    onMouseEnter(ev) {
      ev.stopPropagation();
      clearTimeout(this.timer);
    },
  }
}
</script>

<style lang="less" scoped>
.notice-new {
  background: #F5F9FD;
  .notice-wrapper {
    .wrapper();
    padding: 12px 0px;
    display: flex;
  }
  .icon {
    display: inline-block;
    vertical-align: top;
    background: url("../imgs/horn@2x.png") no-repeat;
    background-size: cover;
    width: 20px;
    height: 20px;
  }
  .content {
    flex: 1 1 0px;
    width: 0px;
    padding: 0px 8px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4679A3;
    line-height: 17px;

    display: flex;
    align-items: center;

    > marquee {
      color: #3d96e2
    }
    > p {
      color: #3d96e2;
      height: auto !important;
      // .line-clamp(4);
    }
  }
}
.notice-arrow {
  position: relative;
  display: inline-block;
  background: url("../imgs/arrow@2x.png") no-repeat;
  background-size: cover;
  width: 12px;
  height: 12px;
  margin: 4px 0px;
  transition: transform 0.3s;
  &.active {
    transform: rotate(180deg);
  }
}
</style>
